<template>
  <a-card :bordered='false'>
    <a-form ref='form' :model='search' :style="{'marginBottom':'20px'}" :initialValues="search"
      :onFinish='pageSearchChange' layout='inline'>
      <a-form-item label="关键字" name='keyword'>
        <a-input v-model:value="search.keyword" :style="{width:'300px'}" placeholder="请输入订单号或产品名进行搜索" />
      </a-form-item>
      <a-form-item>
        <a-button type="primary" htmlType='submit'>搜索</a-button>
      </a-form-item>
    </a-form>
    <a-table :pagination='false' :loading='listLoading' bordered rowKey='order_no' :columns='columns' :data-source='data'>
      <template v-slot:action="{ record }">
        <a v-has:businessOrderDetail="()=>lookMore(record)" href="javascript:;">详情</a>
      </template>
    </a-table>
    <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper
      :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange"
      @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
  </a-card>
  <a-modal  :keyboard="false" title="订单详情" centered v-model:visible="showOrder" :width='1300' :footer="null" destroyOnClose>
    <p class="s_c000 fz-18 s_font_b m-b-20">订单信息</p>
    <div class="s_flex_ali m-b-15">
      <p class="width10 s_c333 text-ar">订单号：</p>
      <p class=' s_c333'>{{orderMore.order_no}}</p>
    </div>
    <div class="s_flex_ali m-b-15">
      <p class="width10 s_c333 text-ar">支付方式：</p>
      <p class=' s_c333'>{{orderMore.pay_type_name}}</p>
    </div>
    <div class="s_flex_ali m-b-15">
      <p class="width10 s_c333 text-ar">订单时间：</p>
      <p class=' s_c333'>{{orderMore.create_time}}</p>
    </div>
    <a-divider />
    <p class="s_c000 fz-18 s_font_b m-b-20">商品清单</p>
    <a-table :pagination='false' bordered rowKey='order_no' :columns='columnsMore' :data-source='dataMore' v-if='orderMore.app_fees_type == 1'></a-table>
    <a-table :pagination='false' bordered rowKey='order_no' :columns='columnsMores' :data-source='dataMore' v-else></a-table>
  </a-modal>
</template>
<script>
  import { ref, onMounted, inject, reactive, toRefs } from "vue";
  import { message } from "ant-design-vue";
  import { getRouter } from "@/utils/app";
  import { setPageState, getPageState } from "@/utils/pageState";
  import { getBusinessOrder,getBusinessOrderMore } from "@/api/system";
  import { iscode } from "@/utils/app";
  let defSearch = {
    page: 1,
    limit: 10,
    keyword:''
  };
  export default {
    components: { },
    setup(props, ctx) {
      // 列表数据和列头配置
      let data = ref([]);
      const search = ref({ ...defSearch });
      const state = reactive({
        listLoading: false,
        total: 1,
        showOrder:false,
        dataMore:[],
        orderMore:{}
      });
      let columns = [
        {
          title: "订单号",
          dataIndex: "order_no",
          key: "order_no",
        },
        {
          title: "产品名称",
          dataIndex: "ref_name",
          key: "ref_name",
        },
        {
          title: "收费模式",
          dataIndex: "app_fees_type_name",
          key: "app_fees_type_name"
        },
        {
          title: "金额（元）",
          dataIndex: "pay_price",
          key: "pay_price",
        },
        {
          title: "订单状态",
          dataIndex: "pay_status_name",
          key: "pay_status_name",
        },
        {
          title: "支付方式",
          dataIndex: "pay_type_name",
          key: "pay_type_name",
        },
        {
          title: "订单时间",
          dataIndex: "create_time",
          key: "create_time",
        },
        {
          title: "操作",
          key: "action",
          width:100,
          slots: { customRender: "action" },
        },
      ];
      const columnsMore = [
        {
          title: "商品信息",
          dataIndex: "name",
          key: "name",
        },
        {
          title: "价格（元/年）",
          dataIndex: "sys_price",
          key: "sys_price",
        },
        {
          title: "年限",
          dataIndex: "valid_year",
          key: "valid_year",
        },
        {
          title: "小计（元）",
          dataIndex: "pay_type_name",
          key: "pay_type_name",
        }
      ];
      const columnsMores = [
        {
          title: "商品信息",
          dataIndex: "name",
          key: "name",
        },
        {
          title: "价格（元）",
          dataIndex: "sys_price",
          key: "sys_price",
        },
        {
          title: "服务费（元/年）",
          dataIndex: "serve_price",
          key: "serve_price",
        },
        {
          title: "年限",
          dataIndex: "valid_year",
          key: "valid_year",
        },
        {
          title: "小计（元）",
          dataIndex: "pay_type_name",
          key: "pay_type_name",
        }
      ];
      const $router = inject('$router')
      const $Modal = inject('$Modal')
      // 分页当前页显示多少条切换
      const pageSearchChange = (current, limit) => {
        search.value.page = 1;
        initData(search.value);
      };
      // 分页当前页切换
      const pageCurrentChange = (page, pageSize) => {
        search.value.page = page;
        initData(search.value);
      };
      // 分页当前页显示多少条切换
      const pageSizeChange = (current, limit) => {
        search.value.page = 1;
        search.value.limit = limit;
        initData(search.value);
      };
      const lookMore = async(e) =>{
        let res = await getBusinessOrderMore({order_no:e.order_no}).then(res => res.data);
          if (iscode(res)) {
            state.orderMore = res.data
            state.dataMore = [res.data]
            state.showOrder= true
          } else {
            message.error(res.msg);
          }
      }
      const initData = async (values) => {
        state.listLoading = true;
        try {
          let res = await getBusinessOrder(values).then(res => res.data);
          state.listLoading = false;
          if (iscode(res)) {
            data.value = res.data.data;
            state.total = res.data.total;
          } else {
            message.error(res.msg);
          }
        } catch (e) {
          state.listLoading = false;
        }
      };


      onMounted(() => {
        initData(search.value);
      });
      return {
        ...toRefs(state),
        search,
        data,
        columns,
        columnsMore,
        columnsMores,
        pageCurrentChange,
        pageSizeChange,
        lookMore,
        pageSearchChange
      };
    },
  };
</script>